<template lang="pug">
footer.footer
  .footer__wrapper
    .content
      FooterLogos
      FooterCopyRights
      FooterDocs

</template>
<script>

import FooterLogos from "./blocks/FooterLogos";
import FooterCopyRights from "./blocks/FooterCopyRights";
import FooterDocs from "./blocks/FooterDocs";
export default {
  name: "MainFooter",
  components: {
    FooterLogos,
    FooterCopyRights,
    FooterDocs,
  },
};
</script>
<style lang="scss">
@import "../style/footer.scss";
</style>
